export class FetchTransactionsArcyParamsList {
  static readonly type = '[ListTransactionsArcyParams] Fetch All';

  constructor(public payload: number) {
  }
}
